import React from 'react';
import TopBarComponent from '../../components/topBar/TopBar.component';

export const RetrenchmentsInfoScreen: React.FC = () => {
  return (
    <>
      <TopBarComponent
        title={'Retrenchments'}
        subTitle={'View Retrenchments Module Information'}
        hideSearch={true}
      ></TopBarComponent>
      <div className="content"></div>
    </>
  );
};
